<template>
  <div class="five-star-cms">
    <page-header @changeDrawerAplication="drawerApplication = !drawerApplication" />
    <div style="margin-top: 80px" class="ml-4 mr-4" v-if="!mobiTablet">
      <v-slide-x-transition :hide-on-leave="true">
        <v-tabs :value="currentTabIndex" background-color="transparent" class="bg-white mb-5 rounded">
          <v-tab v-for="tabItem in tabs" :tabindex="tabItem.index" :key="tabItem.index"
            @click="loadRoute(tabItem.routeName)" v-if="checkRole(tabItem.roles, tabItem.routeName)">{{ tabItem.label
            }}</v-tab>
        </v-tabs>
      </v-slide-x-transition>
      <v-slide-x-transition :hide-on-leave="true">
        <router-view />
      </v-slide-x-transition>
      <v-navigation-drawer v-model="drawerApplication" absolute temporary right class="d-application">
        <div class="d-app">
          <div class="d-app-header">
            <div class="d-flex">
              <div class="d-infomation">
                <v-list-item two-line>
                  <v-list-item-avatar>
                    <img v-if="!user.user.avatar" src="@/assets/svg/account-circle.svg" />
                    <img v-else :src="user.user.avatar">
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title><strong>{{ user.user.fullName }}</strong> - <span class="fs-10">{{ user.user.group
                    }}</span></v-list-item-title>
                    <v-list-item-subtitle>
                      <v-btn color="warning" text x-small class="btn-subtitle" @click="goToPersonalSetting">{{
                        $t("PERSONAL_ACCOUNT_SETTING") }}</v-btn> .
                      <v-btn color="warning" text x-small class="btn-subtitle" @click="logout">{{ $t("LOG_OUT") }}</v-btn>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </div>
            </div>
          </div>
          <div class="d-app-content"  v-if="domain.includes('ezcrs') || domain.includes('ezcms') || domain == 'localhost'">
            <div class="d-search-application">
              <v-text-field class="w-100" v-model="keySearchApp" solo dense
                :label="$t('ENTER_THE_NAME_OF_THE_APP_WANT_TO_SEARCH_FOR')" prepend-inner-icon="search"></v-text-field>
            </div>
            <v-expansion-panels accordion multiple v-model="panel">
              <v-expansion-panel v-for="(item, i) in arrAppView" :key="i">
                <v-expansion-panel-header>{{ $i18n.locale === 'en' ? item.nameEn : item.name }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <b-row>
                    <b-col md="3" v-for="(app, index) in item.appLinks" class="text-center d-app-item py-0"
                      @click="openApp(app)">
                      <div class="d-img-app">
                        <img :src="app.icon">
                      </div>
                      <div class="fs-12">
                        {{ app.name }}
                        <p class="fs-10 text-secondary">{{ $i18n.locale === 'en' ? app.descriptionEn : app.description }}
                        </p>
                      </div>
                    </b-col>
                  </b-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <div class="h-100 d-flex align-items-center justify-content-center" v-if="arrAppView.length === 0">
              {{ $t('REQUEST_EMPTY') }}
            </div>
          </div>
          <div class="d-app-footer">
            <div class="d-flex">
              <div class="mr-auto align-self-center">
                <div @click="changeDevice('MOBILE')" v-if="isMobiTablet && !mobiTablet" class="pl-3">
                  <v-icon class="icon mr-3 text-primary">desktop_access_disabled</v-icon>
                  <span>{{ $t("VIEW_MOBILE_VERSION") }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-navigation-drawer>
    </div>
    <div class="container p-0 main-mobile" style="margin-top: 42px; padding-bottom: 83px !important" v-else>
      <v-slide-x-transition :hide-on-leave="true">
        <router-view />
      </v-slide-x-transition>
    </div>
    <v-bottom-navigation v-model="valuePage" color="primary" v-if="mobiTablet">
      <v-btn @click="changePage('listBooking')">
        <span class="fs-8">{{ $t("BOOKING") }}</span>
        <v-icon>event_note</v-icon>
      </v-btn>

      <v-btn @click="changePage('inventory')">
        <span class="fs-8">{{ $t("ROOM_AVAIL") }}</span>
        <v-icon>inventory</v-icon>
      </v-btn>

        <v-btn @click="changePage('mRate')">
          <span class="fs-8">{{$t("RATE")}}</span>
          <v-icon>star_border</v-icon>
        </v-btn>

      <!-- <v-btn @click="changePage('app')" :value="5">
          <span class="fs-8">{{$t("APP")}}</span>
          <v-icon>apps</v-icon>
        </v-btn> -->

      <v-btn :value="4" @click.stop="drawer = !drawer">
        <span class="fs-8">Menu</span>
        <v-icon>menu</v-icon>
      </v-btn>
    </v-bottom-navigation>
    <v-navigation-drawer v-model="drawer" absolute temporary right>
      <v-list-item>
        <v-list-item-avatar class="mr-2">
          <v-img v-if="!user.user.avatar" src="@/assets/svg/account-circle.svg"></v-img>
          <v-img v-else :src="user.user.avatar" alt></v-img>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>
            <p class="mb-0 font-weight-bold">{{ user.user.fullName }}</p>
            <p class="mb-0 fs-10">{{ user.user.group }}</p>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider class="mt-0 mb-0"></v-divider>

      <v-list>

        <v-list-group :value="true" prepend-icon="language">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title class="fs-10">{{ $t('HOTEL_LOG_lang') }}</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item @click="changeLanguage('vi')">
            <v-list-item-content>
              <v-list-item-title class="fs-10 list-child-title">{{ $t('VIETNAMESE') }} <v-icon
                  class="fs-10 text-success i-dot-active"
                  v-if="$i18n.locale === 'vi'">fiber_manual_record</v-icon></v-list-item-title>
            </v-list-item-content>
            <v-list-item-avata size="25">
              <img src="@/assets/svg/1-i-icon-language-vi.svg" />
            </v-list-item-avata>
          </v-list-item>
          <v-list-item @click="changeLanguage('en')">
            <v-list-item-content>
              <v-list-item-title class="fs-10 list-child-title">{{ $t('ENGLISH') }} <v-icon
                  class="fs-10 text-success i-dot-active"
                  v-if="$i18n.locale === 'en'">fiber_manual_record</v-icon></v-list-item-title>
            </v-list-item-content>
            <v-list-item-avata size="25">
              <img src="@/assets/svg/1-i-icon-language-eng.svg" />
            </v-list-item-avata>
          </v-list-item>
        </v-list-group>
        <v-list-group :value="false" prepend-icon="settings" v-if="checkRoleFunc('STOP_SELL_LIMIT')">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title class="fs-10">{{ $t('OTHER_FUNCTION') }}</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item @click="changePage('stopSell')">
            <v-list-item-content>
              <v-list-item-title class="fs-10 list-child-title">{{ $t('STOP_SELL') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-item @click="changePage('app')"  v-if="domain.includes('ezcrs') || domain.includes('ezcms') || domain == 'localhost'">
          <v-list-item-icon>
            <v-icon>apps</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="fs-10">{{ $t("APP") }}</v-list-item-title>
        </v-list-item>
        <v-list-item @click="changeDevice('DESKTOP')">
          <v-list-item-icon>
            <v-icon>important_devices</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="fs-10">{{ $t("VIEW_DESKTOP_VERSION") }}</v-list-item-title>
        </v-list-item>
        <v-list-item @click="logout()">
          <v-list-item-icon>
            <v-icon>logout</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="fs-10">{{ $t("LOG_OUT") }}</v-list-item-title>
        </v-list-item>
        <v-list-item style="position: absolute; bottom: 0; right: 0">ezCrs {{ version }}</v-list-item>
      </v-list>
    </v-navigation-drawer>
    <ex-alert />
  </div>
</template>

<script>
// import Alert from "@/components/Utils/Alert.vue";
// import Header from "@/components/Utils/Header-Chain.vue";
import { Role } from "@/plugins/roles";
import { authenticationService } from "@/_services";
export default {
  components: {
    // "ex-alert": Alert,
    // "page-header": Header,
    "page-header": () => import('@/components/Utils/Header-Chain.vue'),
  },
  data() {
    return {
      drawer: false,
      currentTabIndex: null,
      valuePage: 4,
      tabs: [
        {
          index: 0,
          label: this.$t("_HOTEL_CHAIN.CHAIN_LIST_HOTEL"),
          routeName: "chain-list",
          roles: [
            // Role.CHAIN,
            // Role.CHAIN_LIST
          ],
        },
        {
          index: 1,
          label: this.$t("BOOKING"),
          routeName: "booking-list",
          roles: [
            // Role.CHAIN,
            Role.BOOKING_CHAIN
          ],
        },
        {
          index: 2,
          label: this.$t("_LIST_USER.LIST_USER"),
          routeName: "listUser",
          roles: [
            // Role.CHAIN,
            Role.USER_MANAGEMENT
          ],
        },
        {
          index: 3,
          label: this.$t("_LIST_GROUP.LIST_GROUP"),
          routeName: "listGroup",
          roles: [
            // Role.CHAIN,
            Role.USER_MANAGEMENT
          ],
        }
      ],
      user: null,
      drawerApplication: false,
      apps: [],
      panel: [0, 1],
      keySearchApp: null,
      arrAppView: []
    };
  },
  created() {
    this.user = JSON.parse(localStorage.getItem("currentUser"))
    let routeName = this.$route.name;
    switch (routeName) {
      case 'chain-list':
        this.currentTabIndex = 0;
        break;
      case 'booking-list':
      case 'chainBookingDetail':
        this.currentTabIndex = 1;
        break;
      case 'listUser':
      case 'addUser':
      case 'editUser':
        this.currentTabIndex = 2;
        break;
      case 'listGroup':
      case 'editGroup':
      case 'addGroup':
        this.currentTabIndex = 3;
        break;
    }
    if (this.domain.includes('ezcrs') || this.domain.includes('ezcms') || this.domain == 'localhost') {
      this.getApplication();
    }
  },
  watch: {
    keySearchApp(val) {
      this.arrAppView = this.filterData(this.apps, val);
    },
  },
  methods: {
    goToPersonalSetting() {
      this.$router.push({ name: "accountSetting" });
    },
    openApp(app) {
      if (app.url) {
        window.open(app.url ? app.url : '#');
      }
    },
    filterData(arr, key) {
      const array = JSON.parse(JSON.stringify(arr));
      if (key) {
        for (let index = 0; index < array.length; index++) {
          array[index].appLinks = array[index].appLinks.filter(app => app.name.toLowerCase().includes(key.toLowerCase()))
        }
        return array.filter(e => e.appLinks.length > 0);
      }
      return arr
    },
    getApplication() {
      authenticationService
        .getApp()
        .then(res => {
          this.apps = res.data;
          this.arrAppView = res.data;
          // this.filterData(this.apps, 'Cms')
        })
    },
    changeDevice(val) {
      localStorage.setItem("device", val);
      this.$router.push({ name: 'chain-list' });
      location.reload();
    },
    changeTab(tabIndex) {
      this.currentTabIndex = tabIndex;
    },
    loadRoute(routeName) {
      this.$router.push({ name: routeName });
    },
    checkRole(roles, routeName) {
      const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
      const userRole = currentUser.user.roles.map(role => role.fnCode);
      let isHide = true;
      for (const role of roles) {
        if (userRole.indexOf(role) >= 0) {
          isHide = false;
          break;
        }
      }

      if (routeName == 'chain-list') {
        isHide = false;
      }
      if (routeName == 'listGroup' && currentUser.user.type != 0) {
        isHide = true;
      }
      if (!isHide) {
        return true;
      } else {
        return false;
      }
    },
    changePage(val) {
      const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
      this.$router.push({
        name: val,
        params: { hotelIdParam: currentUser.hotel.id }
      });
    },
    changeLanguage(lang) {
      localStorage.setItem("systemLanguage", lang);
      location.reload();
    },
    logout() {
      if (this.domain.includes('ezcrs') || this.domain.includes('ezcms') || (this.dataMain && this.dataMain.isLoginAdmin === false)) {
        this.$oidc.signoutRedirect();
      authenticationService.logout();
      } else {
        localStorage.removeItem("arrToken");
        localStorage.removeItem("currentUser");
        this.$router.push({ name: "login-admin" });
      }
     
      // this.$router.push({ name: "login" });
      // // }
      // location.reload();
    },
  },
};
</script>